import { bgcolor, borderRadius, compose, spacing, styled } from "@mui/system";
import { Box } from "@mui/material";
import React from "react";

const LazyImageFixed = styled(({ borderRadius, ...rest }) => (
  <Box component="img" {...rest} />
))(compose(spacing, borderRadius, bgcolor));
export default LazyImageFixed;
